import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import VideoCameraFrontOutlinedIcon from '@mui/icons-material/VideoCameraFrontOutlined';
import type SvgIcon from '@mui/material/SvgIcon';

export type SidebarIconComponent = typeof SvgIcon;

export interface SidebarDestinationIcon {
  outlined: SidebarIconComponent;
  filled: SidebarIconComponent;
}

export const sidebarIcons = {
  rides: { outlined: DirectionsCarFilledOutlinedIcon, filled: DirectionsCarFilledIcon },
  riders: { outlined: GroupsOutlinedIcon, filled: GroupsIcon },
  locations: { outlined: LocationOnOutlinedIcon, filled: LocationOnIcon },
  calendars: { outlined: CalendarMonthOutlinedIcon, filled: CalendarMonthIcon },
  recordings: { outlined: VideoCameraFrontOutlinedIcon, filled: VideoCameraFrontIcon },
  reports: { outlined: AssessmentOutlinedIcon, filled: AssessmentIcon },
  helpCenter: HelpOutlineIcon,
  profile: { outlined: AccountCircleOutlinedIcon, filled: AccountCircleIcon },
};
